import { PaymentMethodsCommandNames, sendRioEvent, SpecType } from '@chegg/commerce-utils';
import { Component } from '../../../constants/CallbackConstants';
import { StatusTypes } from '@chegg/commerce-utils';
import { doFireStatusUpdate, sendRioEventCallback } from '../../../utils/CallbackUtils';
import { createMOPSuccess } from '../PaymentState.actions';
import { ACCOUNT_TYPE } from '../../../constants/PaymentTypes';
import { prependMopToList, setSelectedMop, updateMopList } from '../../MopOnFileState/MopOnFileState.actions';
import { updateDescription } from '../../MopOnFileState/MopOnFileState.helpers';
import { setAppMode } from '../../AppModeState/AppModeState.actions';
import { AppMode } from '../../AppModeState/AppModeState.types';
import { transformMopResponseData } from './transformMopResponseData';
import { getString } from '../../../constants/Strings';
/**
 * handleCreateMopSuccess handles success from create mop API
 */
export var handleCreateMopSuccess = function handleCreateMopSuccess(params) {
  var _payload$rawData;
  var response = params.response,
    dispatch = params.dispatch,
    shouldFireCallbacks = params.shouldFireCallbacks,
    deviceData = params.deviceData,
    paymentMethods = params.paymentMethods,
    goBackMode = params.goBackMode,
    rioNamespace = params.rioNamespace,
    paymentForm = params.paymentForm;
  var payload = transformMopResponseData(response);
  dispatch(createMOPSuccess(payload));
  if (shouldFireCallbacks) {
    doFireStatusUpdate([{
      status: StatusTypes.SUCCESS,
      command: PaymentMethodsCommandNames.FETCH_PAYMENT_METHOD,
      payload: {
        component: Component.PAYMENT_MODULE_LOGIC,
        data: {
          mop: response.data.mopV2,
          deviceData: deviceData
        }
      }
    }]);
  }
  var _ref = payload === null || payload === void 0 || (_payload$rawData = payload.rawData) === null || _payload$rawData === void 0 ? void 0 : _payload$rawData.mopV2,
    accountType = _ref.accountType;
  if (accountType === ACCOUNT_TYPE.VENMO) {
    sendRioEvent({
      info: getString('APP.RIO.EVENTS.EL_NAME.VENMO_MOP_SUCCESS'),
      specType: SpecType.SUCCESS,
      callback: sendRioEventCallback,
      namespace: rioNamespace
    });
  }
  if (accountType === ACCOUNT_TYPE.GOOGLE_PAY) sendRioEvent({
    info: getString('APP.RIO.EVENTS.EL_NAME.GOOGLEPAY_MOP_SUCCESS'),
    specType: SpecType.SUCCESS,
    callback: sendRioEventCallback,
    namespace: rioNamespace
  });
  if (accountType && accountType === ACCOUNT_TYPE.UPI.toLowerCase()) {
    sendRioEvent({
      info: getString('APP.RIO.EVENTS.EL_NAME.UPI_MOP_SUCCESS'),
      specType: SpecType.SUCCESS,
      callback: sendRioEventCallback,
      namespace: rioNamespace
    });
  }
  if (accountType && accountType === ACCOUNT_TYPE.PLACEHOLDER.toLowerCase()) {
    sendRioEvent({
      info: getString('APP.RIO.EVENTS.EL_NAME.PLACEHOLDER_MOP_SUCCESS'),
      specType: SpecType.SUCCESS,
      callback: sendRioEventCallback,
      namespace: rioNamespace
    });
  }
  if (accountType && accountType !== ACCOUNT_TYPE.APPLE_PAY.toLowerCase()) {
    var _payload$rawData2;
    //If the user already has a paypal MOP on file then remove any other Paypal MOPs from the list.
    if (accountType === ACCOUNT_TYPE.PAYPAL_TOKEN) {
      dispatch(updateMopList({
        paymentMethods: paymentMethods.filter(function (pm) {
          return pm.accountType !== ACCOUNT_TYPE.PAYPAL_TOKEN;
        })
      }));
    }
    // prepend the mop to the paymentMethods array
    dispatch(prependMopToList({
      mop: updateDescription(payload === null || payload === void 0 || (_payload$rawData2 = payload.rawData) === null || _payload$rawData2 === void 0 ? void 0 : _payload$rawData2.mopV2, paymentForm)
    }));
  } else {
    var _payload$rawData3;
    dispatch(setSelectedMop({
      mop: payload === null || payload === void 0 || (_payload$rawData3 = payload.rawData) === null || _payload$rawData3 === void 0 ? void 0 : _payload$rawData3.mopV2
    }));
  }
  dispatch(setAppMode({
    mode: AppMode.DEFAULT_MOP,
    goBackMode: goBackMode
  }));
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/redux/PaymentState/helpers/handleCreateMopSuccess.js
// module id = 4392
// module chunks = 11